<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand"
    :class="{ 'navbar-dark': type === 'default' }"
  >
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto"> </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <b-form
        class="navbar-search form-inline mr-sm-3"
        :class="{
          'navbar-search-dark': type === 'default',
          'navbar-search-light': type === 'light',
        }"
        id="navbar-search-main"
      >
        <!-- <vue-bootstrap-typeahead
          placeholder="Buscar"
          v-model="ninoSelected"
          :data="listaNombreNinos"
          @hit="autoninos(ninoSelected)"
        /> -->
      </b-form>
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{
                nombreUsuario
              }}</span>
            </b-media-body>
          </b-media>
        </a>
        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </b-dropdown-header>
          <b-dropdown-item href="#!">
            <i class="ni ni-single-02"></i>
            <span>Mi perfil</span>
          </b-dropdown-item>
          <a @click="cerrarSesion()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Cerrar sesión</span>
          </a>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import axios from "@/directives/axios.js";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  components: {
    VueBootstrapTypeahead,
    CollapseTransition,
    BaseNav,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    nombreUsuario() {
      if (
        this.$store.getters.getDatosUsuario &&
        this.$store.getters.getDatosUsuario.name
      ) {
        return this.$store.getters.getDatosUsuario.name;
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      ninoSelected: "",
      listaNombreNinos: undefined,
    };
  },
  mounted() {
    // this.listaNombreNinos = this.$store.getters.getSimpleCatecumenos.map((element)=>{
    //   return element.apellidosNombre
    // });
  },
  methods: {
    cerrarSesion() {
      axios({
        method: "post",
        url: `/log-out`,
        withCredentials: true,
      })
        .then(() => {
          this.$cookies.remove("catecumen_token");
          this.$router.push({ name: "login" });
          swal.fire({
            title: `Sesión Cerrada Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch(() => {});
    },
    // autoninos(ninoSelected) {
    //   // let idNino = this.$store.getters.getSimpleCatecumenos.find((element) => ninoSelected == element.apellidosNombre);
    // },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
  },
};
</script>
